export const formControlLabelComponentOverrides = {
    MuiFormControlLabel: {
        styleOverrides: {
            root: ({ theme }) => ({
                marginBottom: '0',
                '.MuiFormControlLabel-label, .MuiFormControlLabel-asterisk': {
                    fontSize: theme.typography.button.fontSize,
                    lineHeight: '1.125rem'
                },
                '&.MuiFormControlLabel-labelPlacementStart': {
                    marginLeft: 0
                },
                '&.MuiFormControlLabel-labelPlacementBottom': {
                    marginLeft: 0,
                    alignItems: 'start',
                    '& .MuiSwitch-root': {
                        marginLeft: 0,
                        marginTop: 0
                    }
                },
                '&.MuiFormControlLabel-labelPlacementTop': {
                    marginLeft: 0,
                    alignItems: 'start',
                    '& .MuiSwitch-root': {
                        marginLeft: 0,
                        marginBottom: 0
                    }
                },
                '&:hover': {
                    '& .MuiCheckbox-root, & .MuiRadio-root': {
                        '&:not([aria-readonly="true"]):not(.Mui-disabled)': {
                            color: theme.palette.primary.main
                        }
                    }
                }
            })
        }
    }
};
